import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useSelector } from "react-redux";
import RecommendedCourses from "../RecommendedCourses";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";

const points = [
  <>Get Recognised By Top MNCs And Startups</>,
  <span>
    Increase Salary Up To <span className="font-bold text-white"> 150% </span>
    <img
      alt=""
      width={17}
      src="https://img.learntube.ai/public-assets/Certificate%20Verification%20Screen/spike.png?updatedAt=1750494807792"
      className="ml-1 inline-block"
    />
  </span>,
  <>Stand Out From 20 Million+ Job Seekers</>,
];

const GetCertifiedCard = ({ handlerCertified }) => {
  const userDetails = useSelector(
    (store) => store?.certificateVerification?.userInfo,
  );
  return (
    <div
      className="flex w-full flex-col items-center justify-start rounded-[16px] p-4"
      style={{ background: "rgba(66, 133, 244, 0.15)" }}
    >
      <div className="flex w-full items-center gap-3">
        <img
          src="https://img.learntube.ai/public-assets/Certificate%20Verification%20Screen/Group%2023173.png?updatedAt=1750488521893"
          alt=""
          className="w-[25%]"
        />
        <div className="flex flex-col justify-center">
          <div className="text-[20px] font-semibold text-white md:text-[22px]">
            Get Certified To:
          </div>
          <div className="mt-3 flex flex-col gap-3">
            {points?.map((item, index) => (
              <div className="justiify-start flex items-center gap-[6px] text-[10px] font-medium text-white/70 md:text-[14px]">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="text-[#2BBD13]"
                  size="xl"
                />
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
      <button
        className="mt-5 w-full cursor-pointer rounded-xl border-[2px] border-[#7FC241] px-3 py-3 text-[16px] font-medium text-[#7FC241] md:h-[52px] md:text-[18px]"
        onClick={(e) => {
          Mixpanel.track(
            Constants.Mixpanel
              .CERTIFICATE_VERIFICATION_OWNER_PAGE_GET_CERTIFIED_CLICKED,
          );
          handlerCertified({
            utm_source: "certificate-verification",
            utm_medium: "get-certified",
            is_landing: true,
            is_not_skill: true,
          });
        }}
      >
        Get Certified In Other Subjects
      </button>
      <div className="mt-3 w-full overflow-hidden">
        <RecommendedCourses handlerCertified={handlerCertified} />
      </div>
    </div>
  );
};

export default GetCertifiedCard;
